import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'results', 'form', 'mobileToggle'];

  connect() {
    console.log('search controller connected');
    this.searchShortcut();
    this.showResults();
  }

  mobileToggle() {
    const input = this.inputTarget;
    const form = this.formTarget;

    form.classList.toggle('hidden');
    this.mobileToggleTargets.forEach((element) => {
      element.classList.toggle('hidden');
      element.classList.toggle('lg:inline');
    });

    if (input === document.activeElement) {
      input.blur();
    } else {
      input.focus();
    }
  }

  search() {
    if (this.inputTarget.value.length > 2) {
      // Clear previous timeout if any
      clearTimeout(this.timeout);
      // Debounce the search request
      this.timeout = setTimeout(() => {
        this.formTarget.requestSubmit();
      }, 200);
    } else {
      this.resultsTarget.innerHTML = '';
    }
  }

  searchShortcut() {
    const input = this.inputTarget;
    window.addEventListener('keydown', (e) => {
      const char = (e.metaKey ? '⌘-' : '') + String.fromCharCode(e.keyCode);
      if (char === '⌘-K') {
        if (input === document.activeElement) {
          input.blur();
        } else {
          input.focus();
        }
      }
    });
  }

  showResults() {
    // Remove results container on blur of input
    this.inputTarget.onblur = () => {
      setTimeout(() => {
        this.resultsTarget.innerHTML = '';
      }, 150);
    };
  }

  disconnect() {
    this.resultsTarget.innerHTML = '';
    this.inputTarget.value = '';
  }
}
